
import {take} from 'rxjs/operators';
import { Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { extend, clone } from 'lodash';

import { OfferService } from '../../../offers/services/offer.service';
import { HIGHLIGHT_LEVELS } from '../../consts/highlights';

@Component({
  selector: 'app-dialog-offer-quickedit',
  templateUrl: './dialog-offer-quickedit.component.html',
  styleUrls: ['./dialog-offer-quickedit.component.sass']
})
export class DialogOfferQuickeditComponent implements OnInit {
  offer: any = {};
  highlight_levels = HIGHLIGHT_LEVELS;

  constructor(
    private offerService: OfferService,
    public dialogRef: MatDialogRef<DialogOfferQuickeditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.offer = clone(this.data.offer);
  }

  onConfirm() {
    extend(this.data.offer, this.offer);

    this.offerService.update(this.offer.id, this.offer).pipe(
      take(1))
      .subscribe((response: any) => {
        extend(this.data.offer, this.offer);
      });

    this.dialogRef.close(true);
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
